import React from 'react'
import { getDefaultOrField, getDataCutLabel, formatDate } from 'ps-components/AdvancedTable/GenericGrid/GenericGridCellRenderers'
import { Tooltip } from '@mantine/core';

type Options = {
  addedMatches: number[]
  deletingText: string
  excludeLoadingText?: boolean
  getSurveyJobDetailsPageHref: (cutId: number) => string
  isMarketComparison?: boolean
  isRowDeleting: boolean
  isRowLoading: boolean
  isSummary?: boolean
  loadingText: string
  monetaryRounding: number
  numericRounding: number
  onClick: () => void | null
  onDataCutClick: () => void
  onSelect: (row: any) => void
  percentRounding: number
}

export const SurveyDetails = (rowData: Record<string, any>, _: string, options: Options) => {
  const {
    isRowLoading,
    isRowDeleting,
    loadingText,
    deletingText,
    addedMatches,
    excludeLoadingText,
    getSurveyJobDetailsPageHref
  } = options;
  const cutId = getDefaultOrField(rowData, 'cut_id') || rowData.cutId;
  const effDate = getDefaultOrField(rowData, 'pub_survey_effective_date') || getDefaultOrField(rowData, 'effective_date');
  const surveyJobDetailsHref = getSurveyJobDetailsPageHref ? getSurveyJobDetailsPageHref(cutId) : '';
  const surveyShortName = getDefaultOrField(rowData, 'survey_short_name') || '';

  return (
    <div className="default-cell__survey">
      {!excludeLoadingText && (
        <div className="loading-text">
          {isRowLoading
            ? isRowDeleting
              ? deletingText
              : loadingText
            : addedMatches?.includes(cutId) && <span className="data__cell-added-match">Added to Pricing</span>}
        </div>
      )}

      <Tooltip maw='80%' multiline transitionProps={{ transition: 'fade-up', duration: 500 }} label={getDefaultOrField(rowData, 'job_description')} openDelay={350} withArrow disabled={!getDefaultOrField(rowData, 'job_description')}>
        <div className="default-cell__title">
          <a className="default-cell__title" href={surveyJobDetailsHref} target="_blank" rel="noreferrer">
            {getDefaultOrField(rowData, 'job_title') || 'No title'}
          </a>
          <span className="default-cell__code">{getDefaultOrField(rowData, 'job_code') || ''}</span>
        </div>
      </Tooltip>

      <div className="default-cell__sub-text">
        <div>{`${getDefaultOrField(rowData, 'survey_code') || ''}${
          surveyShortName ? `, ${surveyShortName}` : ''
        }`}</div>
        <div>
          {getDataCutLabel(rowData, options, ',')}
          {`${getDefaultOrField(rowData, 'total_companies') || '-'} cos,
          ${getDefaultOrField(rowData, 'total_incumbents') || '-'} ees,
          ${getDefaultOrField(rowData, 'currency') || 'currency'}, eff ${formatDate(effDate)}`}
        </div>
      </div>
    </div>
  );
};